import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'

export const colorStyles = StyleSheet.create({
	white: {
		color: colorList.WHITE.primary
	}
});
